'use strict';

function hiddenProperty(target, name, value) {
  Object.defineProperty(target, name, {
    configurable: true,
    enumerable: false,
    value: value,
    writable: true
  });
  return target;
}

module.exports = hiddenProperty;



//////////////////
// WEBPACK FOOTER
// ./src/scripts/services/utils/hidden-property.js
// module id = 190
// module chunks = 0